import router from './router'
import lawyerRequestMessages from './localization'

export default {
  router,
  localization: lawyerRequestMessages,
}
